export default __webpack_public_path__ + "static/media/minus.102e8b3c.svg";